import React from 'react';
import './style.scss';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';
import HeaderLanguageSwitcher from './LanguageSwitcher/index.js';
import HeaderSearch from './Search/index.js';
import HeaderButtons from './Buttons/index.js';
import HeaderMenuButton from './MenuButton/index.js';
import clsx from 'clsx';

const AppHeaderTopRow = ({
  menuOpened,
  setMenuOpened,
  searchOpened,
  setSearchOpened,
  disableSearchIcon,
  isEliteTheme,
  ...props
}) => {
  const { logo, navigationLanguages, search, items } = props?.fields;
  const links = items[1]?.fields?.items;

  return (
    <>
      <div className="app-header-top-row ahtr-pc">
        <div className="ahtr-half">
          <a href={`/${props.i18n.language}`}>
            <Image field={logo} className="ahtr-left-logo" />
          </a>
          <HeaderLanguageSwitcher languages={navigationLanguages} isEliteTheme={isEliteTheme} />
          <HeaderSearch
            setOpened={setMenuOpened}
            searchOpened={searchOpened}
            setSearchOpened={setSearchOpened}
            data={search.fields}
            className={clsx('ahtr-search', disableSearchIcon ? 'disabled' : '')}
          />
        </div>
        <div className="ahtr-half">
          <HeaderButtons links={links} isEliteTheme={isEliteTheme} />
        </div>
      </div>
      <div className="app-header-top-row ahtr-mobile">
        <div className="ahtr-half">
          <HeaderButtons links={links} loginOnly isEliteTheme={isEliteTheme} />
        </div>
        <div className="ahtr-middle">
          <a href={`/${props.i18n.language}`}>
            <Image field={logo} className="ahtr-left-logo" />
          </a>
        </div>
        <div className="ahtr-half">
          <HeaderSearch
            setOpened={setMenuOpened}
            searchOpened={searchOpened}
            setSearchOpened={setSearchOpened}
            data={search.fields}
            className={clsx('ahtr-search', disableSearchIcon ? 'disabled' : '')}
          />
          <HeaderMenuButton
            opened={menuOpened}
            setOpened={setMenuOpened}
            searchOpened={searchOpened}
            setSearchOpened={setSearchOpened}
          />
        </div>
      </div>
    </>
  );
};

export default withTranslation()(AppHeaderTopRow);
